import { CURRENT_ENVIRONMENT, APIM_GATEWAY_URLS } from "./config/env";

// ============================================================================
// Base API URL
// ============================================================================

const BASE_API_URL = `${APIM_GATEWAY_URLS[CURRENT_ENVIRONMENT]}`;

// ============================================================================
// Route Constants by Feature Area
// ============================================================================

// migrated to v4 | Entities routes
const ENTITY_BASE_URL = `${BASE_API_URL}/entities`;
// done
export const EntityRoutes = {
  fetchEntity: `${ENTITY_BASE_URL}/{id}`, // GET - was: /entity/{id}
  fetchAllEntities: `${ENTITY_BASE_URL}`, // GET - was: /entities
  updateEntity: `${ENTITY_BASE_URL}/{id}`, // PUT - was: {id}/update
  fetchEntityAudit: `${ENTITY_BASE_URL}/{id}/audit?page={page}`, // GET - was: {id}/audit?page={page}
  fetchEntitiesAudit: `${ENTITY_BASE_URL}/audit?page={page}`, // GET - was: /entities/audit?page={page}
  fetchServiceAudit: `${BASE_API_URL}/{id}/services/audit?page={page}`,
  fetchEntityLsp: `${ENTITY_BASE_URL}/{id}/lsp`, // GET - was: /{id}/lsp TODO: this route is weird.
  updateEntityPlus: `${ENTITY_BASE_URL}/{id}/plus-config`, // PUT - was entity-plus-config/{id}/update`, //
  fetchEntityPlusConfigAudit: `${ENTITY_BASE_URL}/{id}/plus-config/audit?page={page}`, // GET - was /{id}/entity_plus_config/audit?page={page}`,
} as const;

// done
export const AddressRoutes = {
  fetchAddresses: `${BASE_API_URL}/entities/{id}/addresses`, // GET - was: /{id}/addresses
  addAddress: `${BASE_API_URL}/entities/{id}/addresses`, // POST - was: /{id}/addresses/add
  deleteAddress: `${BASE_API_URL}/addresses/{id}`, // DELETE - was: /addresses/delete/{id}
  updateAddress: `${BASE_API_URL}/addresses/{id}`, // PUT - was: /addresses/{id}/update
  fetchAddressAudit: `${BASE_API_URL}/addresses/{id}/audit?page={page}&objectType={objectType}`, // GET - was: /address/{id}/audit?page={page}&objectType={objectType}
} as const;

// donepayslip/matching-results
export const LocaleRoutes = {
  fetchStates: `${BASE_API_URL}/states?country={country}`, // GET - was /locale/states
  fetchCities: `${BASE_API_URL}/cities?country={country}&state={state}`, // GET - was /locale/cities
  fetchHolidays: `${BASE_API_URL}/holidays?country={country}&year={year}`, // GET - was /holidays
} as const;

// done
export const PersonnelRoutes = {
  fetchPersonnel: `${BASE_API_URL}/entities/{id}/personnel`, // GET - was /{id}/personnel
  addPersonnel: `${BASE_API_URL}/entities/{id}/personnel`, // POST - was /{id}/personnel/add
  updatePersonnel: `${BASE_API_URL}/personnel/update/{id}`, // PUT - was /personnel/update/{id}
  deletePersonnel: `${BASE_API_URL}/personnel/delete/{id}`, // DELETE - was /personnel/delete/{id}
  fetchPersonnelAudit: `${BASE_API_URL}/entities/{id}/personnel/audit?page={page}`, // GET - was /{id}/personnel/audit?page={page}
} as const;

// done
export const ShareholderRoutes = {
  // GET - Old v3: /api/{id}/shareholders
  fetchShareholders: `${BASE_API_URL}/entities/{id}/shareholders`,

  // POST - Old v3: /api/{id}/shareholders/add
  addShareholder: `${BASE_API_URL}/shareholders`,

  // PUT - Old v3: /api/shareholder/update/{id}
  updateShareholder: `${BASE_API_URL}/entities/shareholders/{id}?entity_id={entity_id}`,

  // GET - Old v3: /api/shareholders/{id}
  fetchShareholder: `${BASE_API_URL}/entities/shareholders/{id}?entity_id={entity_id}`,

  // GET - Old v3: /api/shareholders/{id}/audit?page={page}&objectType={objectType}
  fetchShareholdersAudit: `${BASE_API_URL}/entities/shareholders/{id}/audit?page={page}&objectType={objectType}`,

  // GET - Old v3: /api/{id}/registry?page={page}&pageSize={pageSize}
  fetchShareholderRegistry: `${BASE_API_URL}/entities/shareholders/{id}/registry?page={page}&pageSize={pageSize}`,

  // GET - Fetches share registry for a specific entity (This Entity tab)
  fetchShareholderRegistryByEntity: `${BASE_API_URL}/entities/shareholders/{shareholderId}/registry?entityId={entityId}&page={page}&pageSize={pageSize}`,

  // POST - Old v3: /api/{shareholder_id}/share_registry/add
  addShareholderRegistry: `${BASE_API_URL}/entities/shareholders/{shareholder_id}/registry`,

  // PUT - Old v3: /api/share_registry/{id}/update
  updateShareholderRegistry: `${BASE_API_URL}/entities/shareholders/registry/{id}`,

  // GET - Old v3: /api/{id}/share_registry/audit?page={page}
  fetchShareholderRegistryAudit: `${BASE_API_URL}/entities/shareholders/{id}/registry/audit?page={page}&entityId={entityId}`,

  // GET - Fetches all share registry transactions for a shareholder across all entities (excludes current entity)
  otherEntitiesRegistry: `${BASE_API_URL}/entities/shareholders/{shareholderId}/registry?page={page}&pageSize={pageSize}&excludeEntityId={excludeEntityId}`,

  // DELETE - Soft delete a specific share registry transaction by registry id
  deleteShareholderRegistry: `${BASE_API_URL}/entities/shareholders/registry/{id}`,

  deleteShareholder: `${BASE_API_URL}/entities/shareholders/{id}?entity_id={entity_id}`,

  restoreShareholder: `${BASE_API_URL}/entities/shareholders/{id}/restore?entity_id={entity_id}`,
} as const;

// done
export const DirectorRoutes = {
  // GET - Old v3: /api/{id}/directors
  fetchDirectors: `${BASE_API_URL}/entities/{id}/directors`,

  // POST - Old v3: /api/{id}/directors/add
  addDirector: `${BASE_API_URL}/directors`,

  // PUT - Old v3: /api/directors/update/{id}
  updateDirector: `${BASE_API_URL}/entities/directors/{id}`,

  // DELETE - Old v3: /api/directors/delete/{id}
  deleteDirector: `${BASE_API_URL}/entities/directors/{directorId}`,

  // GET - Old v3: /api/directors/{id}
  fetchDirector: `${BASE_API_URL}/entities/directors/{id}?entity_id={entity_id}`,

  // GET - Old v3: /api/{id}/directors/audit?page={page}
  fetchDirectorsAudit: `${BASE_API_URL}/entities/{id}/directors/audit?page={page}`,

  directorAppointmentHistory: `${BASE_API_URL}/entities/directors/{directorId}/appointments?entity_id={entityId}`, //✅ Matches v4: GET api/entities/directors/{directorId}/appointments
  updateDirectorAppointment: `${BASE_API_URL}/entities/directors/{directorId}/appointments/{appointmentId}`, //✅ Matches v4: PUT api/entities/directors/{directorId}/appointments/{appointmentId}
  otherEntitiesAppointments: `${BASE_API_URL}/entities/directors/{directorId}/appointments?entity_id={entityId}`, // GET api/entities/directors/{directorId}/appointments - fetches all appointments including other entities
  fetchDuplicateDirectors: `${BASE_API_URL}/tenants/{tenantId}/directors/duplicates`, //✅ Matches v4: PUT api/tenants/{tenantId}/directors/duplicates
  fetchDuplicateShareholders: `${BASE_API_URL}/tenants/{tenantId}/shareholders/duplicates`, //✅ Matches v4: PUT api/tenants/{tenantId}/shareholders/duplicates
  fetchDirectorAudit: `${BASE_API_URL}/director/{id}/audit?page={page}&tab={tab}`, //✅ Matches v4: GET api/director/{id}/audit?page={page}&tab={tab}
  fetchDirectorAppointmentsAudit: `${BASE_API_URL}/entities/{id}/director-appointments/{directorId}/audit?page={page}`, //✅ Matches v4: GET api/entities/{id}/director-appointments/{directorId}/audit?page={page}
} as const;

// done
export const OfficerRoutes = {
  // GET - Old v3: /api/{entity_id}/officers?page={page}&pageSize={pageSize}&search={searchValue}&type={type}&sortBy={sortBy}&sortOrder={sortOrder}
  fetchOfficers: `${BASE_API_URL}/entities/{entity_id}/officers?page={page}&pageSize={pageSize}&search={searchValue}&type={type}&sortBy={sortBy}&sortOrder={sortOrder}`,

  // POST - Old v3: /api/{id}/officers/add
  addOfficer: `${BASE_API_URL}/entities/{id}/officers`,

  // PUT - Old v3: /api/officers/{id}/update
  updateOfficer: `${BASE_API_URL}/entities/officers/{id}`,

  // GET - Old v3: /api/officers/{id}
  fetchOfficer: `${BASE_API_URL}/entities/officers/{id}`,

  // GET - Old v3: /api/officers/{id}/audit?page={page}
  fetchOfficerAudit: `${BASE_API_URL}/entities/officers/{id}/audit?page={page}`,
} as const;

export const AuthRoutes = {
  login: `${BASE_API_URL}/login?key={code}`,
  verifyToken: `${BASE_API_URL}/verify-token`,
  logout: `${BASE_API_URL}/logout`,
} as const;

// migrated to v4
export const UserRoutes = {
  fetchUser: `${BASE_API_URL}/users/current/me`, // GET - was: /user
  fetchWorkosUser: `${BASE_API_URL}/users/{id}`, // GET - was: /user/{id}
  deleteUser: `${BASE_API_URL}/users/{id}`, // DELETE - was: /users/delete/{id}
  fetchUsers: `${BASE_API_URL}/users?page={page}&pageSize={pageSize}&role={role}&search={searchValue}&entity={entity}&service={service}&includeUnassigned={includeUnassigned}&fields={fields}`, // GET - with optional sparse fieldset
  fetchUsersByTenant: `${BASE_API_URL}/users?tenant={tenant}&page={page}&pageSize={pageSize}&sortBy={sortBy}&sortOrder={sortOrder}&fields={fields}`, // GET - fetch users by tenant ID with optional sparse fieldset
  updateUser: `${BASE_API_URL}/users/{id}`, // PUT - was: /user/{id}/update
  addUserEntityAccess: `${BASE_API_URL}/users/{id}/entity-access`, // PUT - was: /users/entity/add-access
  fetchUserEntityAccess: `${BASE_API_URL}/users/{id}/entity-access`, // GET - was: /users/entity-access/{id}
  fetchUserAuditEntityAccess: `${BASE_API_URL}/users/{id}/audit?page={page}`, // GET - was: /{id}/users/audit?page={page}
  removeUserEntityAccess: `${BASE_API_URL}/users/{id}/entity-access`, // DELETE - was: /users/entity/delete-access
  disableNotification: `${BASE_API_URL}/users/current/me/notifications/public-messages`, // PUT - was: /user/config/disable-notification-for-public-messages
} as const;

// migrated to v4
export const LspRoutes = {
  onboarding: `${BASE_API_URL}/lsp/onboard`, // Updated: /lsponboarding → /lsp/onboard
  fetchLsps: `${BASE_API_URL}/lsps`, // done (no change)
  fetchLsp: `${BASE_API_URL}/lsp/{id}`, // done (no change)
  updateLsp: `${BASE_API_URL}/lsp/{id}`, // Updated: removed /update (use PUT method)
  fetchLspsAudit: `${BASE_API_URL}/lsps-audits?page={page}`, // Updated: /lsps/audit → /lsps-audits
  fetchLspAudit: `${BASE_API_URL}/lsp/{id}/audit?page={page}`, // done (no change)
  fetchLspCustomerAudit: `${BASE_API_URL}/lsp/{id}/customer-audit?page={page}`, // Updated: /customer/audit → /customer-audit
} as const;

// done
export const ProcessRoutes = {
  // GET - Old: /milestones/{id}/siblings
  fetchMilestonesSiblings: `${BASE_API_URL}/processes/milestones/{id}/siblings`,

  // GET - Old: /processes/{id} (unchanged)
  fetchProcess: `${BASE_API_URL}/processes/{id}`,

  // DELETE - /processes/{id}
  deleteProcess: `${BASE_API_URL}/processes/{id}`,

  // GET - Old: /processes/{id}/milestones (unchanged)
  fetchMilestones: `${BASE_API_URL}/processes/{id}/milestones`,

  // PUT/PATCH - Old: /tasks/update/{id}
  updateTasks: `${BASE_API_URL}/processes/tasks/{id}`,

  // GET - Old: /process-templates
  fetchProcessType: `${BASE_API_URL}/process-templates`,

  // POST - Old: /{id}/processes/add (entity_id now in body)
  addProcess: `${ENTITY_BASE_URL}/{entity_id}/processes`,

  // GET - Old: /processes/{id}/audit?page={page} (page now in query params)
  fetchProcessAudit: `${BASE_API_URL}/processes/{id}/audit?page={page}`,

  // GET - Old: /processes?page={page}&sortBy={sortBy}&sortOrder={sortOrder}&pageSize={pageSize} (unchanged)
  fetchUserProcesses: `${BASE_API_URL}/processes?page={page}&sortBy={sortBy}&sortOrder={sortOrder}&pageSize={pageSize}&search={search}&status={status}&service={service}&flagged={flagged}&from_date={from_date}&to_date={to_date}`,
  fetchProcessStatusOverview: `${BASE_API_URL}/stats`,
} as const;

// done
export const ConversationRoutes = {
  addMessages: `${BASE_API_URL}/messages/add?relatedId={relatedId}&relatedType={relatedType}`, // V
  fetchPublicMessages: `${BASE_API_URL}/{id}/messages/public`, // V
  fetchInternalMessages: `${BASE_API_URL}/{id}/messages/internal`, // V
  fetchConversations: `${BASE_API_URL}/conversations?isPublic={isPublic}&relatedId={relatedId}&relatedType={relatedType}&page={page}&commentType={commentType}&fetchDataType={fetchDataType}&commentId={commentId}&afterMessageId={afterMessageId}&beforeMessageId={beforeMessageId}`, // V
  deleteConversation: `${BASE_API_URL}/conversations/{id}`, // V, was /conversation/delete/{id}
  restoreConversation: `${BASE_API_URL}/conversations/{id}`,
} as const;

// done
export const DocumentRoutes = {
  // GET method - Fetch documents by type and ID
  // Old: `${BASE_API_URL}/documents?type={type}&id={id}`
  fetchDocuments: `${BASE_API_URL}/documents?type={type}&id={id}`,

  // GET method - Fetch document folders for an entity
  // Old: `${BASE_API_URL}/{id}/document-folders`
  fetchDocumentFolders: `${ENTITY_BASE_URL}/{id}/document-folders`,

  // GET method - Search files with query parameters
  // Old: `${BASE_API_URL}/files/search`
  searchFiles: `${BASE_API_URL}/files/search`,

  // POST method - Add/upload a file
  // Old: `${BASE_API_URL}/files/add?id={id}&type={type}`
  addFile: `${BASE_API_URL}/files`,

  // GET method - Fetch attachment audit trail with pagination
  // Old: `${BASE_API_URL}/attachments/{id}/audit?page={page}&objectType={objectType}`
  fetchAttachmentAudit: `${BASE_API_URL}/attachments/{id}/audit?page={page}&objectType={objectType}`,

  // DELETE - Delete attachment
  deleteAttachment: `${BASE_API_URL}/attachments?relatedId={relatedId}&relatedType={relatedType}`,

  // POST - Restore attachment
  restoreAttachment: `${BASE_API_URL}/attachments/restore`,

  // POST - Add document audit
  addDocumentAudit: `${BASE_API_URL}/attachments/{id}/audit?type={type}`,
  // GET - Fetch sas token for storage
  fetchTemporarySasToken: `${BASE_API_URL}/{container}/sas-token`,
  updateAttachmentTags: `${BASE_API_URL}/fileTags`,
  // POST - Fetch document version
  fetchDocumentVersion: `${BASE_API_URL}/document_version`,
  updateDescription: `${BASE_API_URL}/{id}/description?type={type}`,

  // GET - Fetch Blob download url
  fetchBlobUrl: `${BASE_API_URL}/blob_download?blobUrl={blobUrl}&containerName={containerName}`,

  // POST - Notify employee about tax statement upload
  notifyEmployeeTaxStatement: `${BASE_API_URL}/employee/tax-statement/notify`,
} as const;

// done
export const RequestRoutes = {
  // GET - Old v3: /api/fetch_requests or /api/fetch-requests
  fetchRequests: `${BASE_API_URL}/requests?page={page}&pageSize={pageSize}&filter={filter}&requestType={requestType}`,

  // GET - Old v3: /api/fetch_request/{id} or /api/fetch-request/{id}
  fetchRequest: `${BASE_API_URL}/requests/{id}`,

  // POST - Old v3: /api/add_request or /api/add-request
  addRequest: `${BASE_API_URL}/requests?requestType={requestType}`,

  // PUT - Old v3: /api/update_request_status/{id} or /api/update-request-status/{id}
  updateRequestStatus: `${BASE_API_URL}/requests/{id}/status`,

  // GET - Old v3: /api/fetch_request_documents/{id} or /api/fetch-request-documents/{id}
  fetchRequestDocuments: `${BASE_API_URL}/requests/{id}/documents?requestType={requestType}`,
  fetchRequestAudit: `${BASE_API_URL}/requests/{id}/audit?page={page}`,
} as const;

// done
export const CalendarRoutes = {
  fetchEvents: `${BASE_API_URL}/events?entityId={id}&year={year}&month={month}&day={day}&eventType={eventType}&entity={entity}&service={service}&owner={owner}`, // V, get, same
  fetchUpcomingEvents: `${BASE_API_URL}/events/upcoming`,
} as const;

// done
export const SystemRoutes = {
  getServices: `${BASE_API_URL}/services`, // ✅ Matches v4: GET /api/services
  onboarding: `${BASE_API_URL}/entities`, // Updated: POST /api/entities (entity onboarding)
  organizations: `${BASE_API_URL}/organizations`, // ✅ Matches v4: GET /api/organizations
  listTenants: `${BASE_API_URL}/tenants?page={page}&pageSize={pageSize}&sortBy={sortBy}&sortOrder={sortOrder}&search={search}&status={status}&type={type}&country={country}&account_manager={account_manager}`, // ✅ Matches v4: GET /api/tenants
  createTenant: `${BASE_API_URL}/tenants`, // ✅ Matches v4: POST /api/tenants
  verifyDomain: `${BASE_API_URL}/domains/verify`, // ✅ Matches v4: GET /api/domains/verify
  fetchTenant: `${BASE_API_URL}/tenants/{id}`, // ✅ Matches v4: GET /api/tenants/{id}
  fetchTenantEntities: `${BASE_API_URL}/tenants/{id}/entities?page={page}&pageSize={pageSize}&sortBy={sortBy}&sortOrder={sortOrder}`,
  addTenantEntityAccess: `${BASE_API_URL}/tenants/{lspTenantId}/entity-access`, // ✅ Matches v4: POST api/tenants/{lspTenantId}/entity-access
  removeTenantEntityAccess: `${BASE_API_URL}/tenants/{lspTenantId}/entity-access/{entityId}`, // ✅ Matches v4: DELETE api/tenants/{lspTenantId}/entity-access/{entityId}
  fetchTenantEntityAccess: `${BASE_API_URL}/tenants/{id}/entity-access?page={page}&pageSize={pageSize}&sortBy={sortBy}&sortOrder={sortOrder}`, // ✅ Matches v4: GET api/tenants/{id}/entity-access
  updateTenantEntityAccess: `${BASE_API_URL}/tenants/{lspTenantId}/entity-access/{entityId}`, // ✅ Matches v4: PUT api/tenants/{lspTenantId}/entity-access/{entityId}
  fetchEntitesByTenant: `${BASE_API_URL}/tenants/{tenant_id}/entities?page={page}&pageSize={pageSize}&sortBy={sortBy}&sortOrder={sortOrder}`, // ✅ Matches v4: GET api/tenants/{tenant_id}/entities
  accountManagers: `${BASE_API_URL}/account-managers`, // ✅ GET /api/account-managers
  fetchTenantChildEntity: `${BASE_API_URL}/tenants/{lspTenantId}/entity-access`, // ✅ Matches v4: POST api/tenants/{tenant_id}/entities
  fetchTenantAudit: `${BASE_API_URL}/tenants/{id}/audit?page={page}`, // GET - Fetch tenant audit logs (pageSize can be added via replace if needed, supports optional objectType)
  fetchTenantEntityAccessAudit: `${BASE_API_URL}/tenants/{id}/entity-access/audit?page={page}`, // GET - Fetch tenant entity access audit logs
  fetchTenantUserAssignmentsAudit: `${BASE_API_URL}/tenants/{id}/assigned-users/audit?page={page}`, // GET - Fetch tenant user assignments audit logs
} as const;

// done
export const CommentRoutes = {
  // POST - Add comment to task
  addComments: `${BASE_API_URL}/comments?id={taskId}&type=TASK`,

  // GET - Fetch comments for task
  fetchComments: `${BASE_API_URL}/comments?id={taskId}&page={page}`,
};

export const EmployeeRoutes = {
  createEmployee: `${BASE_API_URL}/entities/{id}/employee`,
  fetchEmployeeAudit: `${BASE_API_URL}/employee/audit?page={page}&objectType={objectType}&relatedId={id}`,
  fetchEmployees: `${ENTITY_BASE_URL}/{id}/employee?page={page}&pageSize={pageSize}&search={search}&sortBy={sortBy}&sortOrder={sortOrder}`,
  checkEmployeeId: `${BASE_API_URL}/entities/{entityId}/employeeId`,
};

// Payslip Routes
export const PayslipRoutes = {
  // POST - add payslip processing message
  addPayslipProcessingMessage: `${BASE_API_URL}/payslip/processing_message/add?relatedId={relatedId}&relatedType={relatedType}`,
  payslipMatching: `${BASE_API_URL}/payslip/matching_results/{id}?status={status}`,
  addPaySlipMacthingResults: `${BASE_API_URL}/payslip/matching_results/add`,
  updatePayslipMatchingResults: `${BASE_API_URL}/payslip/matching-results`, // PUT - update payslip matching results
  restorePayslipMatchingResult: `${BASE_API_URL}/payslip/matching_results/restore/{id}`,
  triggerPayslipMatching: `${BASE_API_URL}/payslips_matching/trigger`, // POST - trigger payslip matching results
  manualMatchPayslips: `${BASE_API_URL}/payslips_matching/manual_match`,
};

// Account Manager
export const AccountManagerRoutes = {
  fetchAccountManagerDetails: `${BASE_API_URL}/account-managers/{id}`, // ✅ Matches v4: GET api/account-managers/{id}
  updateAccountManagerDetails: `${BASE_API_URL}/account-managers/{id}`, // ✅ Matches v4: PATCH api/account-managers/{id}
  fetchManagedEntities: `${BASE_API_URL}/{account_manager_id}/managed-entities?page={page}&pageSize={pageSize}&sortBy={sortBy}&sortOrder={sortOrder}`, // ✅ Matches v4: GET api/{account_manager_id}/managed-entities
  fetchAccountManagerAudit: `${BASE_API_URL}/account-manager/{id}/audit?page={page}`, //✅ Matches v4: GET api/account-manager/{id}/audit
  fetchAccountManagerEntitiesAudit: `${BASE_API_URL}/account-manager/{id}/entities/audit?page={page}`, //✅ Matches v4: GET api/account-manager/{id}/entities/audit
};

// Bulk Import Routes
export const BulkImportRoutes = {
  importPayrollPlusTasks: `${BASE_API_URL}/bulk-import/payroll-plus-tasks`,
} as const;

// end todo

// ============================================================================
// Structured API Routes (New Implementation)
// ============================================================================

export const ApiRoutes = {
  entity: EntityRoutes,
  address: AddressRoutes,
  locale: LocaleRoutes,
  personnel: PersonnelRoutes,
  shareholder: ShareholderRoutes,
  director: DirectorRoutes,
  officer: OfficerRoutes,
  auth: AuthRoutes,
  user: UserRoutes,
  lsp: LspRoutes,
  process: ProcessRoutes,
  conversation: ConversationRoutes,
  document: DocumentRoutes,
  request: RequestRoutes,
  calendar: CalendarRoutes,
  system: SystemRoutes,
  payslip: PayslipRoutes,
  bulkImport: BulkImportRoutes,
} as const;

// ============================================================================
// Legacy API_ROUTES Object (For Backward Compatibility)
// ============================================================================

export const API_ROUTES_V2 = {
  // Entity Routes
  FETCH_ENTITY: EntityRoutes.fetchEntity,
  ALL_ENTITIES: EntityRoutes.fetchAllEntities,
  UPDATE_ENTITY: EntityRoutes.updateEntity,
  FETCH_ENTITY_AUDIT: EntityRoutes.fetchEntityAudit,
  FETCH_ENTITIES_AUDIT: EntityRoutes.fetchEntitiesAudit,
  FETCH_ENTITY_LSP: EntityRoutes.fetchEntityLsp,
  UPDATE_ENTITY_PLUS: EntityRoutes.updateEntityPlus,
  FETCH_ENTITY_PLUS_CONFIG_AUDIT: EntityRoutes.fetchEntityPlusConfigAudit,
  FETCH_SERVICE_AUDIT: EntityRoutes.fetchServiceAudit,

  // Address Routes
  FETCH_ADDRESSES: AddressRoutes.fetchAddresses,
  ADD_ADDRESS: AddressRoutes.addAddress,
  DELETE_ADDRESS: AddressRoutes.deleteAddress,
  UPDATE_ADDRESS: AddressRoutes.updateAddress,
  FETCH_ADDRESS_AUDIT: AddressRoutes.fetchAddressAudit,

  // Locale Routes
  FETCH_STATES: LocaleRoutes.fetchStates,
  FETCH_CITIES: LocaleRoutes.fetchCities,
  FETCH_HOLIDAYS: LocaleRoutes.fetchHolidays,

  // Personnel Routes
  PERSONNEL: PersonnelRoutes.fetchPersonnel,
  ADD_PERSONNEL: PersonnelRoutes.addPersonnel,
  UPDATE_PERSONNEL: PersonnelRoutes.updatePersonnel,
  DELETE_PERSONNEL: PersonnelRoutes.deletePersonnel,
  FETCH_PERSONNEL_AUDIT: PersonnelRoutes.fetchPersonnelAudit,

  // Shareholder Routes
  SHARE_HOLDERS: ShareholderRoutes.fetchShareholders,
  ADD_SHARE_HOLDER: ShareholderRoutes.addShareholder,
  UPDATE_SHAREHOLDER: ShareholderRoutes.updateShareholder,
  FETCH_SHAREHOLDER: ShareholderRoutes.fetchShareholder,
  FETCH_SHAREHOLDERS_AUDIT: ShareholderRoutes.fetchShareholdersAudit,
  FETCH_SHAREHOLDER_REGISTRY: ShareholderRoutes.fetchShareholderRegistry,
  FETCH_SHAREHOLDER_REGISTRY_BY_ENTITY:
    ShareholderRoutes.fetchShareholderRegistryByEntity,
  ADD_SHAREHOLDER_REGISTRY: ShareholderRoutes.addShareholderRegistry,
  UPDATE_SHAREHOLDER_REGISTRY: ShareholderRoutes.updateShareholderRegistry,
  FETCH_SHAREHOLDER_REGISTRY_AUDIT:
    ShareholderRoutes.fetchShareholderRegistryAudit,
  OTHER_ENTITIES_REGISTRY: ShareholderRoutes.otherEntitiesRegistry,
  DELETE_SHAREHOLDER_REGISTRY: ShareholderRoutes.deleteShareholderRegistry,
  DELETE_SHAREHOLDER: ShareholderRoutes.deleteShareholder,
  RESTORE_SHAREHOLDER: ShareholderRoutes.restoreShareholder,

  // Director Routes
  FETCH_DIRECTORS: DirectorRoutes.fetchDirectors,
  ADD_DIRECTOR: DirectorRoutes.addDirector,
  UPDATE_DIRECTOR: DirectorRoutes.updateDirector,
  DELETE_DIRECTOR: DirectorRoutes.deleteDirector,
  FETCH_DIRECTOR: DirectorRoutes.fetchDirector,
  FETCH_DIRECTORS_AUDIT: DirectorRoutes.fetchDirectorsAudit,
  FETCH_DIRECTOR_AUDIT: DirectorRoutes.fetchDirectorAudit,
  DIRECTOR_APPOINTMENT_HISTORY: DirectorRoutes.directorAppointmentHistory,
  UPDATE_DIRECTOR_APPOINTMENT: DirectorRoutes.updateDirectorAppointment,
  OTHER_ENTITIES_APPOINTMENTS: DirectorRoutes.otherEntitiesAppointments,
  FETCH_DUPLICATE_DIRECTORS: DirectorRoutes.fetchDuplicateDirectors,
  FETCH_DUPLICATE_SHAREHOLDERS: DirectorRoutes.fetchDuplicateShareholders,
  FETCH_DIRECTOR_APPOINTMENTS_AUDIT:
    DirectorRoutes.fetchDirectorAppointmentsAudit,

  // Officer Routes
  FETCH_OFFICERS: OfficerRoutes.fetchOfficers,
  ADD_OFFICER: OfficerRoutes.addOfficer,
  UPDATE_OFFICER: OfficerRoutes.updateOfficer,
  FETCH_OFFICER: OfficerRoutes.fetchOfficer,
  FETCH_OFFICER_AUDIT: OfficerRoutes.fetchOfficerAudit,

  // Auth Routes
  LOGIN: AuthRoutes.login,
  VERIFY_TOKEN: AuthRoutes.verifyToken,
  LOGOUT: AuthRoutes.logout,

  // User Routes
  FETCH_USER: UserRoutes.fetchUser,
  FETCH_WORKOS_USER: UserRoutes.fetchWorkosUser,
  DELETE_USER: UserRoutes.deleteUser,
  FETCH_USERS: UserRoutes.fetchUsers,
  FETCH_USERS_BY_TENANT: UserRoutes.fetchUsersByTenant,
  UPDATE_USER: UserRoutes.updateUser,
  ADD_USER_ENTITY_ACCESS: UserRoutes.addUserEntityAccess,
  FETCH_USER_ENTITY_ACCESS: UserRoutes.fetchUserEntityAccess,
  FETCH_USER_AUDIT_ENTITY_ACCESS: UserRoutes.fetchUserAuditEntityAccess,
  REMOVE_USER_ENTITY_ACCESS: UserRoutes.removeUserEntityAccess,
  DISABLE_NOTIFICATION: UserRoutes.disableNotification,

  // LSP Routes
  LSPONBOARDING: LspRoutes.onboarding,
  FETCH_LSPS: LspRoutes.fetchLsps,
  FETCH_LSP: LspRoutes.fetchLsp,
  UPDATE_LSP: LspRoutes.updateLsp,
  FETCH_LSPS_AUDIT: LspRoutes.fetchLspsAudit,
  FETCHLSP_AUDIT: LspRoutes.fetchLspAudit,
  FETCH_LSP_CUSTOMER_AUDIT: LspRoutes.fetchLspCustomerAudit,

  // Account Manager Routes
  FETCH_ACCOUNT_MANAGERS: SystemRoutes.accountManagers,
  CREATE_ACCOUNT_MANAGER: SystemRoutes.accountManagers,

  // Process Routes
  FETCH_PROCESS: ProcessRoutes.fetchProcess,
  DELETE_PROCESS: ProcessRoutes.deleteProcess,
  FETCH_MILESTONES: ProcessRoutes.fetchMilestones,
  FETCH_MILESTONES_SIBLINGS: ProcessRoutes.fetchMilestonesSiblings,
  UPDATE_TASKS: ProcessRoutes.updateTasks,
  FETCH_PROCESS_TYPE: ProcessRoutes.fetchProcessType,
  ADD_PROCESS: ProcessRoutes.addProcess,
  FETCH_PROCESS_AUDIT: ProcessRoutes.fetchProcessAudit,
  FETCH_USER_PROCESSES: ProcessRoutes.fetchUserProcesses,
  PROCESS_STATUS_OVERVIEW: ProcessRoutes.fetchProcessStatusOverview,

  // Conversation Routes
  ADD_MESSAGES: ConversationRoutes.addMessages,
  FETCH_PUBLIC_MESSAGES: ConversationRoutes.fetchPublicMessages,
  FETCH_INTERNAL_MESSAGES: ConversationRoutes.fetchInternalMessages,
  FETCH_CONVERSATIONS: ConversationRoutes.fetchConversations,
  DELETE_CONVERSATION: ConversationRoutes.deleteConversation,
  RESTORE_CONVERSATION: ConversationRoutes.restoreConversation,

  // Document Routes
  FETCH_DOCUMENTS: DocumentRoutes.fetchDocuments,
  FETCH_DOCUMENT_FOLDERS: DocumentRoutes.fetchDocumentFolders,
  FETCH_FILES: DocumentRoutes.searchFiles, // issue here.
  ADD_FILE: DocumentRoutes.addFile,
  FETCH_ATTACHMENT_AUDIT: DocumentRoutes.fetchAttachmentAudit,
  DELETE_ATTACHMENT: DocumentRoutes.deleteAttachment,
  RESTORE_ATTACHMENT: DocumentRoutes.restoreAttachment,
  ADD_DOCUMENT_AUDIT: DocumentRoutes.addDocumentAudit,
  FETCH_TEMPORARY_TOKEN: DocumentRoutes.fetchTemporarySasToken,
  UPDATE_ATTACHMENT_TAGS: DocumentRoutes.updateAttachmentTags,
  FETCH_DOCUMENT_VERSION: DocumentRoutes.fetchDocumentVersion,
  FETCH_BLOB_URL: DocumentRoutes.fetchBlobUrl,
  UPDATE_DESCRIPTION: DocumentRoutes.updateDescription,
  NOTIFY_EMPLOYEE_TAX_STATEMENT: DocumentRoutes.notifyEmployeeTaxStatement,

  // Request Routes
  FETCH_REQUESTS: RequestRoutes.fetchRequests,
  FETCH_REQUEST: RequestRoutes.fetchRequest,
  ADD_REQUEST: RequestRoutes.addRequest,
  UPDATE_REQUEST_STATUS: RequestRoutes.updateRequestStatus,
  FETCH_REQUEST_DOCUMENTS: RequestRoutes.fetchRequestDocuments,
  FETCH_REQUEST_AUDIT: RequestRoutes.fetchRequestAudit,

  // Calendar Routes
  FETCH_EVENTS: CalendarRoutes.fetchEvents,
  FETCH_UPCOMING_EVENTS: CalendarRoutes.fetchUpcomingEvents,

  // System Routes
  GET_SERVICES: SystemRoutes.getServices,
  ONBOARDING: SystemRoutes.onboarding,
  ORGANIZATIONS: SystemRoutes.organizations,
  LIST_TENANTS: SystemRoutes.listTenants,
  CREATE_TENANT: SystemRoutes.createTenant,
  VERIFY_DOMAIN: SystemRoutes.verifyDomain,
  FETCH_TENANT: SystemRoutes.fetchTenant,
  FETCH_TENANT_ENTIIES: SystemRoutes.fetchTenantEntities,
  UPDATE_TENANT: SystemRoutes.fetchTenant,
  ADD_TENANT_ENTITIES_ACCESS: SystemRoutes.addTenantEntityAccess,
  REMOVE_TENANT_ENTITY_ACCESS: SystemRoutes.removeTenantEntityAccess,
  FETCH_TENANT_ENTITY_ACCESS: SystemRoutes.fetchTenantEntityAccess,
  UPDATE_TENANT_ENTITY_ACCESS: SystemRoutes.updateTenantEntityAccess,
  FETCH_ENTITIES_BY_TENANT: SystemRoutes.fetchEntitesByTenant,
  FETCH_TENANT_ADMIN_INFO_AUDIT: SystemRoutes.fetchTenantAudit, // Alias for backward compatibility
  FETCH_TENANT_AUDIT: SystemRoutes.fetchTenantAudit,
  FETCH_TENANT_ENTITY_ACCESS_AUDIT: SystemRoutes.fetchTenantEntityAccessAudit,
  FETCH_TENANT_USER_ASSIGNMENTS_AUDIT:
    SystemRoutes.fetchTenantUserAssignmentsAudit,

  // Comment Routes
  ADD_COMMENTS: CommentRoutes.addComments,
  FETCH_COMMENTS: CommentRoutes.fetchComments,

  // Employee Registry Routes
  CERATE_EMPLOYEE: EmployeeRoutes.createEmployee,
  FETCH_EMPLOYEES: EmployeeRoutes.fetchEmployees,
  FETCH_EMPLOYEE_AUDIT: EmployeeRoutes.fetchEmployeeAudit,
  CHECK_EMPLOYEE_ID: EmployeeRoutes.checkEmployeeId,

  // Account Manager Routes
  FETCH_ACCOUNT_MANAGER_DETAILS:
    AccountManagerRoutes.fetchAccountManagerDetails,
  UPDATE_ACCOUNT_MANAGER_DETAILS:
    AccountManagerRoutes.updateAccountManagerDetails,
  FETCH_MANAGED_ENTIIES: AccountManagerRoutes.fetchManagedEntities,
  FETCH_ACCOUNT_MANAGER_AUDIT: AccountManagerRoutes.fetchAccountManagerAudit,
  FETCH_ACCOUNT_MANAGER_ENTITIES_AUDIT:
    AccountManagerRoutes.fetchAccountManagerEntitiesAudit,

  // Permissions Routes
  CHECK_PERMISSION: `${BASE_API_URL}/permissions/check`,

  //Payslip Routes
  ADD_PAYSLIP_PROCESSING_MESSAGE: PayslipRoutes.addPayslipProcessingMessage,
  PAYSLIP_MATCHING: PayslipRoutes.payslipMatching,
  ADD_PAYSLIP_MATCHING_RESULTS: PayslipRoutes.addPaySlipMacthingResults,
  UPDATE_PAYSLIP_MATCHING_RESULTS: PayslipRoutes.updatePayslipMatchingResults,
  RESTORE_PAYSLIP_MATCHING_RESULT: PayslipRoutes.restorePayslipMatchingResult,
  TRIGGER_PAYSLIP_MATCHING_RESULTS: PayslipRoutes.triggerPayslipMatching,
  MANUAL_MATCH_PAYSLIPS: PayslipRoutes.manualMatchPayslips,
} as const;

// ============================================================================
// Exports
// ============================================================================

export { CURRENT_ENVIRONMENT as ENV };
export default API_ROUTES_V2;
